import { render } from "./Festival.vue?vue&type=template&id=f01bf0b0"
import script from "./Festival.vue?vue&type=script&lang=js"
export * from "./Festival.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__